import type { IconSvgObject } from './types';

const CircleArrowOutDownLeftIcon: IconSvgObject = [
  ["path", { d: "M4.22302 13C4.07706 12.3568 4 11.6874 4 11C4 6.02944 8.02944 2 13 2C17.9706 2 22 6.02944 22 11C22 15.9706 17.9706 20 13 20C12.3126 20 11.6432 19.9229 11 19.777", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 12L2 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 16V22H8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default CircleArrowOutDownLeftIcon;
